// extracted by css-extract-rspack-plugin
export default {"ColumnGroupName":"dgPpc"};